import { render, staticRenderFns } from "./edtails.vue?vue&type=template&id=7957f7f0&scoped=true&"
import script from "./edtails.vue?vue&type=script&lang=js&"
export * from "./edtails.vue?vue&type=script&lang=js&"
import style0 from "./edtails.vue?vue&type=style&index=0&id=7957f7f0&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7957f7f0",
  null
  
)

export default component.exports